import { ProjectSerieResponse } from '@/types/service-response'
import { ShiftEmployeeDetails } from '@/model/planning/ShiftEmployeeDetails'
import { AdditionalGroup } from '@/model/additional-fields/AdditionalGroup'

export class EditShiftPlan {
  private constructor (
    readonly shiftId: number | null,
    readonly shiftName: string,
    readonly typeOfShift: string | null,
    readonly profitcenter: number | null,
    readonly department: number | null,
    readonly sachbearbeiter: number | null,
    readonly referenzTermin: string,
    readonly monday: string,
    readonly tuesday: string,
    readonly wednesday: string,
    readonly thursday: string,
    readonly friday: string,
    readonly saturday: string,
    readonly sunday: string,
    readonly whlg: string,
    readonly unique: string,
    readonly endAfterTimes: string,
    readonly endAfterDate: string,
    readonly provisorich: string,
    readonly fixed: string,
    readonly dateStart: string,
    readonly dateEnd: string,
    readonly projectSerieId: number | null,
    readonly projectId: number | null,
    readonly address: string,
    readonly referenzProjektId: number | null,
    readonly abonnementId: number | null,
    readonly details: Array<ShiftEmployeeDetails>,
    readonly additionalFields: AdditionalGroup[],
  ) {}

  public static createListFromResponse (data: ProjectSerieResponse[]): Array<EditShiftPlan> {
    return data.map((item: ProjectSerieResponse) => {

      const details: Array<ShiftEmployeeDetails> = ShiftEmployeeDetails.createListFromResponse(item.details)
      const additionalFields: AdditionalGroup[] = AdditionalGroup.createFromResponse(item.Zusatzfelder)

      return new EditShiftPlan(
        item.SchichtID,
        item.Schichtname,
        item.TypeOfShift,
        item.profitcenter,
        item.Abteilung,
        item.Sachbearbeiter,
        item.ReferenzTermin ? item.ReferenzTermin : '',
        item.Montag,
        item.Dienstag,
        item.Mittwoch,
        item.Donnerstag,
        item.Freitag,
        item.Samstag,
        item.Sonntag,
        item.Whlg,
        item.Einmalig,
        item.EndAfternTimes,
        item.EndAfterDate ? item.EndAfterDate : '',
        item.provisorisch,
        item.fixiert,
        item.datumStart ? item.datumStart : '',
        item.datumEnd ? item.datumEnd : '',
        item.ProjektSerieID,
        item.ProjektID,
        item.Adresse,
        item.ReferenzProjektID,
        item.AbonnementID,
        details,
        additionalFields
      )
    })
  }
}
